import React, { useState, useEffect } from 'react';
import { locomotorasService } from '../../../services/api';

const ITEMS_EXTERIOR = [
  { key: 'fugas_ext', label: 'No hay fugas de lubricante, combustible, agua o aire' },
  { key: 'sueltas_ext', label: 'No hay piezas sueltas o que arrastren' },
  { key: 'danos_ext', label: 'No hay daños que impidan la circulacion' },
  { key: 'mangueras_ext', label: 'Mangueras y llaves de acoplamiento de freno correctas' },
  { key: 'organos_ext', label: 'Organos de traccion y choque en perfecto estado' },
  { key: 'acople_ext', label: 'Acople en modo Shafenberg' },
  { key: 'guarniciones_ext', label: 'Guarniciones de freno en buenas condiciones' },
  { key: 'grifo_ext', label: 'Grifo de aislamiento engrase de pestanas abierto' },
  { key: 'arena_ext', label: 'Nivel de arena en areneros correcto' },
  { key: 'layover_ext', label: 'NO conectada alimentacion externa 400V LAYOVER' },
  { key: 'disyuntores_ext', label: 'Todos los disyuntores en posicion ON' },
  { key: 'combustible_ext', label: 'Nivel de combustible en el tanque comprobado' },
];

const ITEMS_INTERIOR = [
  { key: 'fugas_int', label: 'Sin fugas de combustible, lubricante, agua o aire' },
  { key: 'aceite_int', label: 'Nivel aceite sistema hidraulico refrigeracion correcto' },
  { key: 'mangueras_int', label: 'Mangueras de mando multiple en correcto estado' },
  { key: 'agua_int', label: 'Nivel agua circuito refrigeracion del motor correcto' },
  { key: 'urea_int', label: 'Nivel de Urea en la DDU correcto' },
  { key: 'parabrisas_int', label: 'Agua lavaparabrisas suficiente en DDU' },
  { key: 'diesel_int', label: 'Nivel aceite lubricante motor diesel comprobado' },
  { key: 'abb_int', label: 'Nivel refrigerante armarios potencia ABB correcto' },
  { key: 'calentador_int', label: 'Disyuntores e interruptores ON (excepto pre-calentador)' },
  { key: 'operacion_int', label: 'Seccionador puesta a tierra en posicion OPERACION' },
  { key: 'normal_int', label: 'Conmutadores en posicion NORMAL' },
  { key: 'sellado_int', label: 'Correcto sellado de los interruptores' },
  { key: 'z4_int', label: 'Paneles de freno normalizados y llave Urea Z4 igual' },
  { key: 'regimen_int', label: 'Modo de freno apropiado G (mercancias) o P (pasajeros)' },
  { key: 'aislamiento_int', label: 'Todas las llaves de aislamiento abiertas' },
  { key: 'caja_int', label: 'Existencia y estado de elementos en caja correctos' },
  { key: 'cabina_int', label: 'Existencia y estado de elementos en cabina correctos' },
];

function ItemCheck({ label, value, onChange }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 0', borderBottom: '1px solid #f0f0f0' }}>
      <div style={{ flex: 1, fontSize: 14, lineHeight: 1.4, color: '#333' }}>{label}</div>
      <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
        <button onClick={() => onChange(true)} style={{ width: 44, height: 44, borderRadius: 8, border: `2px solid ${value === true ? '#3b6d11' : '#ddd'}`, background: value === true ? '#eaf3de' : '#fff', cursor: 'pointer', fontSize: 18, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>✓</button>
        <button onClick={() => onChange(false)} style={{ width: 44, height: 44, borderRadius: 8, border: `2px solid ${value === false ? '#a32d2d' : '#ddd'}`, background: value === false ? '#fcebeb' : '#fff', cursor: 'pointer', fontSize: 18, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>✗</button>
      </div>
    </div>
  );
}

export default function ChecklistPrevioForm({ locoId, inicial, onGuardar, onVolver }) {
  const init = inicial || {};
  const [loco, setLoco] = useState(null);
  const [seccion, setSeccion] = useState('datos');

  const [fecha, setFecha] = useState(init.fecha || new Date().toISOString().split('T')[0]);
  const [hora, setHora] = useState(init.hora || new Date().toTimeString().slice(0, 5));
  const [baseMto, setBaseMto] = useState(init.base_mto || '');
  const [kmInicio, setKmInicio] = useState(init.km_inicio || '');
  const [litrosCombustibleInicio, setLitrosCombustibleInicio] = useState(init.litros_combustible_inicio || '');

  const [items, setItems] = useState(() => {
    const obj = {};
    [...ITEMS_EXTERIOR, ...ITEMS_INTERIOR].forEach(i => obj[i.key] = init[i.key] ?? null);
    return obj;
  });
  const [observaciones, setObservaciones] = useState(init.observaciones || '');

  useEffect(() => {
    locomotorasService.getAll().then(r => {
      const l = r.data.find(l => l.id === locoId);
      if (l) {
        setLoco(l);
        if (!init.km_inicio) setKmInicio(l.km_actuales || '');
        if (!init.litros_combustible_inicio) setLitrosCombustibleInicio(l.litros_combustible || '');
      }
    });
  }, [locoId]);

  const totalItems = ITEMS_EXTERIOR.length + ITEMS_INTERIOR.length;
  const marcados = Object.values(items).filter(v => v !== null).length;
  const noAptos = Object.values(items).filter(v => v === false).length;

  const secciones = ['datos', 'exterior', 'interior'];
  const seccionIdx = secciones.indexOf(seccion);

  const guardar = () => {
    if (!kmInicio || !litrosCombustibleInicio) {
      alert('Rellena los KM y litros de combustible de inicio'); return;
    }
    onGuardar({
      fecha, hora, base_mto: baseMto,
      km_inicio: parseFloat(kmInicio),
      litros_combustible_inicio: parseFloat(litrosCombustibleInicio),
      ...items, observaciones
    });
  };

  return (
    <div style={{ maxWidth: 600, margin: '0 auto', padding: '16px', fontFamily: 'system-ui, sans-serif' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
        <button onClick={onVolver} style={{ padding: '8px 12px', borderRadius: 8, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 14 }}>←</button>
        <div style={{ flex: 1 }}>
          <h1 style={{ fontSize: 18, fontWeight: 600, margin: 0 }}>Checklist inicio</h1>
          <p style={{ fontSize: 12, color: '#888', margin: '2px 0 0' }}>
            {loco?.numero} · {marcados}/{totalItems} items
            {noAptos > 0 && <span style={{ color: '#a32d2d', marginLeft: 6 }}>· {noAptos} no aptos</span>}
          </p>
        </div>
      </div>

      <div style={{ display: 'flex', gap: 6, marginBottom: 16 }}>
        {[
          { key: 'datos', label: 'Datos inicio' },
          { key: 'exterior', label: 'Exterior' },
          { key: 'interior', label: 'Interior' },
        ].map(s => (
          <button key={s.key} onClick={() => setSeccion(s.key)} style={{
            flex: 1, padding: '9px 4px', borderRadius: 8, border: 'none', cursor: 'pointer', fontSize: 12, fontWeight: 500,
            background: seccion === s.key ? '#1a1a1a' : '#f0f0f0',
            color: seccion === s.key ? '#fff' : '#555'
          }}>{s.label}</button>
        ))}
      </div>

      {seccion === 'datos' && (
        <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e5e5e5', padding: 16, marginBottom: 16 }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
            <div>
              <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Fecha</label>
              <input type="date" value={fecha} onChange={e => setFecha(e.target.value)}
                style={{ width: '100%', padding: '10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 14 }} />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Hora inicio</label>
              <input type="time" value={hora} onChange={e => setHora(e.target.value)}
                style={{ width: '100%', padding: '10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 14 }} />
            </div>
          </div>
          <div style={{ marginBottom: 12 }}>
            <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Base MTO / Actividad programada</label>
            <input value={baseMto} onChange={e => setBaseMto(e.target.value)}
              placeholder="Ej: Exploracion MDC"
              style={{ width: '100%', padding: '10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 14 }} />
          </div>
          <div style={{ marginBottom: 12 }}>
            <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>KM odometro inicio</label>
            <input type="number" value={kmInicio} onChange={e => setKmInicio(e.target.value)}
              style={{ width: '100%', padding: '10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 14 }} />
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <div>
              <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Litros combustible inicio</label>
              <input type="number" value={litrosCombustibleInicio} onChange={e => setLitrosCombustibleInicio(e.target.value)}
                style={{ width: '100%', padding: '10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 14 }} />
            </div>
          </div>
        </div>
      )}

      {seccion === 'exterior' && (
        <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e5e5e5', padding: '0 16px', marginBottom: 16 }}>
          {ITEMS_EXTERIOR.map(item => (
            <ItemCheck key={item.key} label={item.label} value={items[item.key]}
              onChange={v => setItems({ ...items, [item.key]: v })} />
          ))}
        </div>
      )}

      {seccion === 'interior' && (
        <div>
          <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e5e5e5', padding: '0 16px', marginBottom: 16 }}>
            {ITEMS_INTERIOR.map(item => (
              <ItemCheck key={item.key} label={item.label} value={items[item.key]}
                onChange={v => setItems({ ...items, [item.key]: v })} />
            ))}
          </div>
          <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e5e5e5', padding: 16, marginBottom: 16 }}>
            <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 6 }}>Observaciones</label>
            <textarea value={observaciones} onChange={e => setObservaciones(e.target.value)} rows={3}
              placeholder="Observaciones..."
              style={{ width: '100%', padding: '10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 14, resize: 'none', boxSizing: 'border-box' }} />
          </div>
        </div>
      )}

      <div style={{ display: 'flex', gap: 8 }}>
        {seccionIdx > 0 && (
          <button onClick={() => setSeccion(secciones[seccionIdx - 1])} style={{ flex: 1, padding: '14px', borderRadius: 12, border: '1px solid #ddd', background: '#fff', color: '#333', fontSize: 15, fontWeight: 500, cursor: 'pointer' }}>
            ← Anterior
          </button>
        )}
        {seccionIdx < secciones.length - 1 ? (
          <button onClick={() => setSeccion(secciones[seccionIdx + 1])} style={{ flex: 1, padding: '14px', borderRadius: 12, border: 'none', background: '#1a1a1a', color: '#fff', fontSize: 15, fontWeight: 600, cursor: 'pointer' }}>
            Siguiente →
          </button>
        ) : (
          <button onClick={guardar} style={{ flex: 1, padding: '14px', borderRadius: 12, border: 'none', background: '#1a1a1a', color: '#fff', fontSize: 15, fontWeight: 600, cursor: 'pointer' }}>
            Guardar checklist inicio
          </button>
        )}
      </div>
    </div>
  );
}
